import React from 'react';
import { graphql, Link } from 'gatsby';
const ModularButtonBlock = ({ data }) => {
  const {
    backgroundColor,
    noBottomPadding,
    noTopPadding,
    textAlign,
    buttonPath,
    buttonText,
    buttonPdf,
  } = data;
  return (
    <div className={`modular-button-block-container ${backgroundColor}`}>
      <div
        className={`modular-global-width ${
          noBottomPadding && 'modular-padding-large-no-bottom'
        } ${noTopPadding && 'modular-padding-large-no-top'} ${
          !noBottomPadding && !noBottomPadding && 'modular-padding-large'
        }`}
      >
        <div
          className={`${textAlign && textAlign} ${
            !textAlign && 'default-align'
          }`}
        >
          {buttonPdf ? (
            <a
              href={buttonPdf.url}
              target="_blank"
              className={`${
                backgroundColor === 'White' ? 'button' : 'button-blue'
              }`}
            >
              {buttonText}
            </a>
          ) : (
            <Link
              to={buttonPath}
              className={`${
                backgroundColor === 'White' ? 'button' : 'button-blue'
              }`}
            >
              {buttonText}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModularButtonBlock;
export const fragment = graphql`
  fragment ModularButtonBlock on DatoCmsButtonBlock {
    internal {
      type
    }
    backgroundColor
    noTopPadding
    noBottomPadding
    textAlign
    buttonPdf {
      url
    }
    buttonPath
    buttonText
  }
`;
